export default "__VITE_ASSET__CuUsHRD___"